const STORAGE_KEY = "v2-sidebar-collapsed-sections";

/**
 * The persisted set is the *collapsed* sections, not the open ones. That way a section added to
 * navConfig later — or one that is renamed, invalidating its stored key — is absent from the set
 * and therefore shows expanded, never hidden.
 */
export const readCollapsedSections = (): string[] | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((key): key is string => typeof key === "string") : null;
  } catch {
    return null;
  }
};

export const writeCollapsedSections = (keys: string[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
  } catch {
    // Storage full or unavailable — the menu still works, it just forgets between visits.
  }
};

/**
 * On the first visit, before the user has folded anything themselves, only the section they are
 * standing in is expanded. Once a stored set exists it wins verbatim.
 */
export const initialCollapsedSections = (
  sectionKeys: string[],
  activeKey: string | undefined,
  stored: string[] | null,
): string[] => stored ?? sectionKeys.filter((key) => key !== activeKey);
